/*
 * Simulcast VP8 (bucket filling algorithm).
 *
 * This table will only be used by getCustomMaxBitrateArray to compute
 * the maximum bitrate that will be later assigned to each of the
 * sender's encoding parameters.
*/
const multipleEncodingBitrateTable = {
  FHD: { DEFAULT: 5e+6, BW_SAVER: 1.2e+6, EXTRA_BW_SAVER: 3.5e+5 },
  HD: { DEFAULT: 2.5e+6, BW_SAVER: 5e+5, EXTRA_BW_SAVER: 1.5e+5 },
  qHD: { DEFAULT: 1.2e+6, BW_SAVER: 3.5e+5, EXTRA_BW_SAVER: 1.5e+5 },
  VGA: { DEFAULT: 5e+5, BW_SAVER: 1.5e+5, EXTRA_BW_SAVER: 1.5e+5 },
};

/*
 * Non-simulcast VP8, (SVC and Non-SVC) VP9 and H.264 (bitrate-preset).
 *
 * This table will only be used by getPresetMaxBitrateArray to compute
 * the maximum bitrate that will be later assigned to each of the
 * sender's encoding parameters.
*/
const singleEncodingBitrateTable = {
  FHD: { BW_SAVER: 1e+6, EXTRA_BW_SAVER: 3e+5 },
  HD: { BW_SAVER: 8e+5, EXTRA_BW_SAVER: 2.5e+5 },
  qHD: { BW_SAVER: 6e+5, EXTRA_BW_SAVER: 1.5e+5 },
  VGA: { BW_SAVER: 4.5e+5, EXTRA_BW_SAVER: 1e+5 },
};

export { multipleEncodingBitrateTable, singleEncodingBitrateTable };
